import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./Login.scss";
import 'toasted-notes/src/styles.css';
import {LoginRequest, MessageHandler, Validation,fixNumbers} from "../../Services";
import {useHistory } from "react-router-dom";
import Logo from '../../assets/images/logo.png';
import {useLocation} from "react-router";



function Login() {


    //hooks
    const history = useHistory();
    const location = useLocation();

    // states
    const [mobile,setMobile] = useState("");
    const [loginState,setLoginState] = useState(false);
    const [btnState,setBtnState] = useState(true);
    const [suggestParsed,setSuggestParsed] = useState([]);
    const [suggestSwitch,setSuggestSwitch] = useState(false)
    const [suggest,setSuggest] = useState([
        {mobile:"09123658985"},
        {mobile:"0912345543"},
        {mobile:"0915467777"},
        {mobile:"0918345554"}
        ]);



    // Login Method -------------------------------------------------------------------
     const Login_Request = async () => {
         if(loginState){return }
         // pre request
         setLoginState(true);

         if (!Validation({type:"MOBILE",val:fixNumbers(mobile)})){
             MessageHandler({type:"VALIDATION",status:"MOBILE"})
             setLoginState(false);
             return ;
         }

         //request
         try{
             let response = await LoginRequest({phone:fixNumbers(mobile)})

             //post success request
             setLoginState(false);



             //set Mobile to Suggestion
             let suggestion_obj = [];
             let suggestion_storage = localStorage.getItem("mobileSuggestion");
             if(suggestion_storage){
                 suggestion_obj = JSON.parse(suggestion_storage);
             }

             //Check Suggestion Exist
             let exist = suggestion_obj.find(item=>item.mobile===fixNumbers(mobile))
             if(!exist){
                 suggestion_obj.push({mobile:fixNumbers(mobile)})
             }
             localStorage.setItem("mobileSuggestion",JSON.stringify(suggestion_obj))

             //clear
             if(location.state && location.state.mall){
                 history.push("/verify",{
                     token:response.data.token,mobile:mobile,
                     mall:location.state.mall
                 }
             )
                }
             else {
                 history.push("/verify",{token:response.data.token,mobile:mobile})
             }

             MessageHandler({type:"LOGIN",status:"SUCCESS"})
         }catch (e) {
             //post failed request
             // console.log(e)
             setLoginState(false);
             MessageHandler({type:"LOGIN",status:"ERROR"})
         }
    }

    const updateWindowDimensions = () => {
        if(window.innerHeight<380){
            setBtnState(false)
        }else {
            setBtnState(true)
        }
    }



    useEffect(()=>{
        // console.log("State : ",location)
        window.addEventListener('resize',updateWindowDimensions);
        let suggestion_storage = localStorage.getItem("mobileSuggestion");
        if(suggestion_storage){
            let suggestion_parsed = JSON.parse(suggestion_storage);
            setSuggestParsed(suggestion_parsed)
        }

        return () => {window.addEventListener('resize',updateWindowDimensions)}
    },[])

    const onEnter = (event, callback) => event.key  === 'Enter' && callback()
    const enterEvent = () => Login_Request();

    const doSuggest = (val) =>{
        if(val===""){
            setSuggest([])
            setSuggestSwitch(false)
            return false;
        }
        //sug list
        if(suggestParsed.length>0){
            let result =  suggestParsed.filter(item=>item.mobile.search(fixNumbers(val))>-1);
            if(result.length>0){
                setSuggest(result)
                setSuggestSwitch(true)
            }else {
                setSuggest([])
                setSuggestSwitch(false)
            }
        }
    }

    return(
        <div className="otp-container">
            {/*<span onClick={()=>history.push("/scan")}>SCAN</span>*/}
            <div className="otp-logo">
                <img src={Logo} alt="Digi Mall"/>
            </div>

            <div className="otp-message">
                <div className="otp-message">
                    <span>.برای ادامه لطفا وارد شوید</span>
                </div>
            </div>

            <div className="otp-input">
                <input
                    value={mobile}
                    onChange={(e)=>{
                        setMobile(e.target.value)
                        doSuggest(e.target.value)
                    }}
                    onKeyPress={e => onEnter(e, enterEvent)}
                    autoComplete="off"
                    type="text" name="mobile" id="mobile" placeholder="شماره موبایل"/>
                <SimpleLineIcon name="screen-smartphone"/>
                {suggestSwitch?<div className="suggest-list">
                    {suggest.slice(0,3).map(item=>{
                        return(
                            <div className="suggest-list-item" onClick={()=>{
                                setMobile(item.mobile)
                                setSuggest([])
                                setSuggestSwitch(false)
                            }}>
                                <span>{item.mobile}</span>
                            </div>
                        )
                    })}
                </div>:null}
            </div>



            {btnState?<div className="top-float-send-btn">
                <div className="float-btn" onClick={Login_Request}>
                    {loginState?<i className="fa fa-spinner fa-spin"></i>: <img src="/other/arrow-left.png" alt=""/>}
                    ورود
                    <span style={{fontSize:17}}></span>
                </div>
            </div>:null}
        </div>
    )
}

export {Login}

